import { Component, OnInit, ViewChild } from "@angular/core";
import {
  CalendarEvent,
  CalendarMonthViewBeforeRenderEvent,
  CalendarView,
} from "angular-calendar";
import { isSameDay, isSameMonth } from "date-fns";
import { Subject } from "rxjs";

import * as moment from "moment";
import { CommonService } from "../services/common.service";
import { ToastrService } from "ngx-toastr";
import { Router } from "@angular/router";
import { Location } from "@angular/common";
import { InquiryFormComponent } from "../shared/inquiry-form/inquiry-form.component";
import { DATE_FORMATS } from "./../services/utils";

@Component({
  selector: "app-booking",
  templateUrl: "./booking.component.html",
  styleUrls: ["./booking.component.scss"],
})
export class BookingComponent implements OnInit {
  @ViewChild(InquiryFormComponent) inquiryFormComponent: InquiryFormComponent;

  loading: boolean = false;
  isSubmitted: boolean = false;
  isMobileView: boolean = false;
  isCancelVisible: boolean = false;
  isMemberVisible: boolean = false;
  isCategoryVisible: boolean = false;
  isSlotOnlyLoading: boolean = false;
  headerData = null;
  category = null;
  members = null;

  view: CalendarView = CalendarView.Month;
  CalendarView = CalendarView;
  // viewDate: Date = new Date();
  viewDate: any = this.commonService.onDateFilter();
  refresh: Subject<any> = new Subject();
  activeDayIsOpen: boolean = true;
  lastBookingDate: string;
  categoryLabelName = null;
  selectedCategory: any = null;
  selectedPerson: any = null;
  selectedDate = null;
  public_holiday = [];
  timeSlots = [];
  selectedSlot = null;
  isSlotError: boolean = false;
  bookingDetails = {
    category: {
      category_name: "-",
    },
    member: {
      personnel: "-",
    },
    personnelLabel: "-",
    date: "-",
    time: "-",
    name: "-",
    phone: "-",
    email: "-",
    isVideoConf: "No",
  };
  selectedDaysForHighlight = [];
  dateFormats = DATE_FORMATS;

  constructor(
    private router: Router,
    private location: Location,
    private commonService: CommonService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.isMobileView = this.commonService.isMobile();
    this.headerData = this.commonService.newAppointmentData.headerData;
    this.category = this.commonService.newAppointmentData.categoryData;
    this.selectedCategory = history.state?.category_id
      ? history.state.category_id
      : null;
    if (this.category?.length) {
      this.isCategoryVisible = true;
      this.onChangeCategory();
    }
    if (!this.commonService.newAppointmentData.slug) {
      const localStorageSlug = sessionStorage.getItem("slug");
      this.commonService.newAppointmentData.slug = localStorageSlug;
      this.commonService.newAppointmentData.appointmentType = 2;
    }
    this.selectedDate = moment(new Date()).format("DD-MM-YYYY");
    this.bookingDetails.date = this.selectedDate;
    this.getMetaData();
    this.getTeamMembers();
    this.getAvailableSlots();
  }

  public goBack() {
    this.location.back();
  }

  private getTeamMembers() {
    this.commonService.getTagTeamMembers().subscribe((data: any) => {
      if (data.code === 200) {
        this.members = data.data;
        if (this.members && this.members.length) {
          this.members.forEach((element) => {
            element.manager_first_name = this.commonService.capitalizeString(
              element.manager_first_name
            );
            element.manager_last_name = this.commonService.capitalizeString(
              element.manager_last_name
            );
            element.name =
              element.manager_first_name + " " + element.manager_last_name;
          });
        }
      }
    });
  }

  private getMetaData() {
    this.commonService.getAppointmentMetaData().subscribe((data: any) => {
      if (data.code === 200) {
        let res = data.data;
        let headerData = {
          outlet: res.business_outlet_name,
          business: res.business_name,
          business_logo: res.business_logo,
          is_welcome_banner_text: this.isMobileView
            ? res.appointment_setting_details.is_short_welcome_banner_text
            : res.appointment_setting_details.is_welcome_banner_text,
          welcome_banner_text: this.isMobileView
            ? res.appointment_setting_details.short_welcome_banner_text
            : res.appointment_setting_details.welcome_banner_text,
        };
        // this.categoryLabelName = res.appointment_setting_details.display_name;
        this.categoryLabelName = this.commonService.capitalizeString(
          res.appointment_setting_details.display_name
        );
        this.bookingDetails.personnelLabel =
          res.appointment_setting_details.display_name;
        this.commonService.newAppointmentData.headerData = headerData;
        this.headerData = headerData;
        headerData = null;
        this.public_holiday = res.public_holiday;
        this.lastBookingDate =
          data.data.appointment_setting_details.last_booking_date;

        if (
          res.appointment_setting_details.consumer_booking_type?.toUpperCase() ==
          "BOTH"
        ) {
          this.isCancelVisible = true;
        }

        //setting theme color set in the appointment settings
        const primaryColor =
          res.appointment_setting_details.primary_color_theme;
        sessionStorage.setItem("theme_color", primaryColor);
        this.commonService.newAppointmentData.themeColor = primaryColor;
        document.documentElement.style.setProperty(
          "--custom-color",
          primaryColor
        );
        document.documentElement.style.setProperty(
          "--custom-color-100",
          this.commonService.convertHexToRgb(primaryColor, 0.1)
        );

        if (!this.category) {
          let catData = [];
          res.categories?.forEach((element: any) => {
            if (element?.category_name && element.category_name.length) {
              element.active = false;
              element.category_name = this.commonService.capitalizeString(
                element?.category_name
              );
              catData.push(element);
            }
          });

          if (res.appointment_setting_details.enable_appointment_category) {
            this.category = catData;
            this.commonService.newAppointmentData.categoryData = catData;
            if (this.category?.length) {
              this.isCategoryVisible = true;
            }
          } else {
            this.category = [];
          }
        }

        if (
          !res.appointment_setting_details.auto_assign_team_member &&
          (res.appointment_setting_details.tag_team_member_setting?.toUpperCase() ==
            "BOTH" ||
            res.appointment_setting_details.tag_team_member_setting?.toUpperCase() ==
              "CONSUMER")
        ) {
          this.isMemberVisible = true;
        }
        this.refresh.next();
      }
    });
  }

  public goNext() {
    this.isSubmitted = true;

    if (
      (this.category?.length && !this.selectedCategory) ||
      (this.isMemberVisible && !this.selectedPerson) ||
      !this.selectedDate ||
      !this.selectedSlot ||
      this.isSlotError
    ) {
      return;
    }

    let categoryData = this.category?.find(
      (category: any) => this.selectedCategory == category.category_id
    );
    let tagTeamMember = this.members?.find(
      (member: any) => this.selectedPerson == member.manager_id
    );
    if (tagTeamMember && tagTeamMember.manager_first_name) {
      tagTeamMember.personnel =
        tagTeamMember.manager_first_name +
        " " +
        tagTeamMember.manager_last_name;
    }

    let data = {
      isCategoryVisible: this.isCategoryVisible,
      isMemberVisible: this.isMemberVisible,
      category: categoryData,
      member: tagTeamMember,
      date: this.selectedDate,
      time: this.selectedSlot,
      personnelLabel: this.categoryLabelName,
    };
    sessionStorage.setItem(
      "bookingDetails",
      JSON.stringify(this.bookingDetails)
    );
    this.isSubmitted = false;
    this.router.navigateByUrl("customer/booking-inquiry", {
      state: data,
      // replaceUrl: true,
    });
  }

  public onChangeCategory() {
    let categoryData = this.category?.find(
      (category: any) => this.selectedCategory == category.category_id
    );
    if (categoryData && categoryData.category_name) {
      this.bookingDetails.category = categoryData;
    }
  }

  public onChangeMember() {
    let tagTeamMember = this.members?.find(
      (member: any) => this.selectedPerson == member.manager_id
    );
    if (tagTeamMember && tagTeamMember.manager_first_name) {
      this.bookingDetails.member.personnel =
        tagTeamMember.manager_first_name +
        " " +
        tagTeamMember.manager_last_name;
    }
    if (this.selectedDate) {
      this.getAvailableSlots(true);
    }
  }

  closeOpenMonthViewDay() {
    this.activeDayIsOpen = false;
  }

  // dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
  //   if (isSameMonth(date, this.viewDate)) {
  //     this.viewDate = date;
  //     if (
  //       (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
  //       events.length === 0
  //     ) {
  //       this.activeDayIsOpen = false;
  //     } else {
  //       this.activeDayIsOpen = true;
  //     }
  //   }
  // }

  dayClicked(data) {
    this.selectedDaysForHighlight.push(data);
    this.selectedDaysForHighlight.forEach((element: any) => {
      if (element?.cssClass) {
        delete element.cssClass;
      }
    });

    data.cssClass = "cal-day-selected";
    if (data.isPast) {
      this.toastr.error("You can not select past dates for appointment");
      this.timeSlots = [];
      this.isSlotError = true;
      this.bookingDetails.date = moment(data.date).format("DD-MM-YYYY");
      // this.bookingDetails.date = "-";
      this.bookingDetails.time = "-";
      this.selectedDate = null;
    } else if (
      moment(data.date).isBetween(
        moment(this.commonService.getDate()),
        moment(this.lastBookingDate, "DD-MM-YYYY"),
        "days",
        "[]"
      )
    ) {
      // selected date should between today and end date
      // handled allow advance booking settings.
      this.selectedDate = moment(data.date).format("DD-MM-YYYY");
      let holiday = this.public_holiday.some((v) => {
        return (
          moment(v.date).format("YYYY-MM-DD") ==
          moment(this.selectedDate, "DD-MM-YYYY").format("YYYY-MM-DD")
        );
      });
      if (holiday) {
        this.toastr.error(
          "This is holiday for business. Please select other date for appointment."
        );
        this.selectedDate = null;
        this.timeSlots = [];
        this.isSlotError = true;

        this.bookingDetails.date = moment(data.date).format("DD-MM-YYYY");
        // this.bookingDetails.date = "-";
        this.bookingDetails.time = "-";
      } else {
        this.isSlotError = false;
        this.selectedDate = moment(data.date).format("DD-MM-YYYY");
        this.bookingDetails.date = this.selectedDate;
        // get slots
        this.getAvailableSlots(true);
      }
    } else {
      // handled allow advance booking settings.
      this.toastr.error(
        "You can not select that much far dates for appointment"
      );
      this.timeSlots = [];
      this.isSlotError = true;
      this.bookingDetails.date = moment(data.date).format("DD-MM-YYYY");
      // this.bookingDetails.date = "-";
      this.bookingDetails.time = "-";
    }
  }

  beforeMonthViewRender(renderEvent: CalendarMonthViewBeforeRenderEvent): void {
    renderEvent.body.forEach((day) => {
      day.isToday =
        moment(day.date).format("DD-MM-YYYY") ==
        moment(this.commonService.onDateFilter()).format("DD-MM-YYYY");
      day.isToday && (day.isPast = false);
      const dateOfMonth = day.date;
      let isBetween = moment(dateOfMonth).isBetween(
        moment(this.commonService.getDate()),
        moment(this.lastBookingDate, "DD-MM-YYYY"),
        "days",
        "[]"
      );
      if (!isBetween) {
        day.cssClass = "bg-cellDisabled";
      }
      if (day.isToday) {
        (day.cssClass = "cal-day-selected"),
          this.selectedDaysForHighlight.push(day);
      }
    });
  }

  getAvailableSlots(isSlotUpdateOnly = false) {
    if (isSlotUpdateOnly) {
      this.isSlotOnlyLoading = true;
    } else {
      this.loading = true;
    }
    let bookingPayload = {
      date: moment(this.selectedDate, this.dateFormats.dateFirst).format(
        this.dateFormats.yearFirst
      ),
      tag_team_member: this.selectedPerson ? this.selectedPerson : null,
    };
    this.commonService.getBookingSlots(bookingPayload).subscribe(
      (data: any) => {
        if (data.code === 200) {
          this.bookingDetails.time = "-";
          this.selectedSlot = null;
          this.timeSlots = [];
          this.timeSlots = data.data.slots?.filter(
            (slot: any) => slot.status === 0
          );
          if (!this.timeSlots.length) {
            this.isSlotError = true;
            this.bookingDetails.time = "-";
          } else {
            this.isSlotError = false;
          }

          if (isSlotUpdateOnly) {
            this.isSlotOnlyLoading = false;
          } else {
            this.loading = false;
          }
        }
      },
      (error) => {
        this.isSlotError = true;
        this.timeSlots = [];
        this.bookingDetails.time = "-";
        if (isSlotUpdateOnly) {
          this.isSlotOnlyLoading = false;
        } else {
          this.loading = false;
        }
        console.log("error in getBookingSlots", error);
        if (!this.isMobileView) {
          this.selectedDate = null;
        }
        this.toastr.error(error.error.message);
      }
    );
  }

  public selectSlot(index: number) {
    this.timeSlots.forEach((element: any) => {
      element.active = false;
    });
    this.timeSlots[index].active = true;
    this.selectedSlot = this.timeSlots[index];
    // this.bookingDetails.time = this.selectedSlot?.slot_time;
    this.bookingDetails.time = this.selectedSlot;
  }

  public show12HrTime(time) {
    return this.commonService.format12HourTime(time);
  }

  public isValidData() {
    if (this.category?.length && !this.isMemberVisible) {
      return (
        this.selectedDate &&
        this.selectedSlot &&
        this.selectedCategory &&
        !this.isSlotError
      );
    } else if (this.category?.length && this.isMemberVisible) {
      return (
        this.selectedDate &&
        this.selectedSlot &&
        this.selectedCategory &&
        this.selectedPerson &&
        !this.isSlotError
      );
    } else if (this.isMemberVisible) {
      return (
        this.selectedDate &&
        this.selectedSlot &&
        this.selectedPerson &&
        !this.isSlotError
      );
    } else {
      return this.selectedDate && this.selectedSlot && !this.isSlotError;
    }
  }
}
